export default __webpack_public_path__ + "static/media/elle9.10f2a84a.webp";